import React from "react";
import Skeleton from "components/Skeleton";
import { useTelegramSubscribers } from "hooks/useTelegramSubscribers";
import { useAuth } from "utilities/auth";
import { isInternal } from "utilities/userType";
import { Users } from "lucide-react";

export default function SubscribersTab() {
  const { user } = useAuth();
  const isAdmin = isInternal(user);
  const { subscribers, loading, error } = useTelegramSubscribers();

  if (error) return <p className="text-destructive">Error loading subscribers: {error.message}</p>;

  return (
    <div className="surface rounded-xl ring-1 ring-border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead className="bg-muted">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">Channel Name</th>
              {isAdmin && (
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">Company ID</th>
              )}
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">Chat ID</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">Registered At</th>
            </tr>
          </thead>

          <tbody className="bg-card divide-y divide-border">
            {loading &&
              [0, 1, 2].map((i) => (
                <tr key={i}>
                  {[0, 1, 2, ...(isAdmin ? [3] : [])].map((j) => (
                    <td key={j} className="px-6 py-4">
                      <Skeleton.Rect className="h-4 w-24" />
                    </td>
                  ))}
                </tr>
              ))}

            {!loading &&
              subscribers.map((s) => (
                <tr key={s._id || s.chatId}>
                  <td className="px-6 py-4 text-sm font-medium">{s.name || s.merchantName || "Unnamed"}</td>
                  {isAdmin && (
                    <td className="px-6 py-4 text-sm text-muted-foreground font-mono">{s.companyId}</td>
                  )}
                  <td className="px-6 py-4 text-sm text-muted-foreground font-mono">{s.chatId}</td>
                  <td className="px-6 py-4 text-sm text-muted-foreground">
                    {s.registeredAt ? new Date(s.registeredAt).toLocaleDateString() : "—"}
                  </td>
                </tr>
              ))}

            {!loading && subscribers.length === 0 && (
              <tr>
                <td colSpan={isAdmin ? 4 : 3} className="px-6 py-16 text-center">
                  <Users className="h-10 w-10 mx-auto text-muted-foreground mb-3" />
                  <p className="text-muted-foreground">No subscribers registered.</p>
                  <p className="text-sm text-muted-foreground mt-1">
                    Use the /register command in the Telegram bot to subscribe.
                  </p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
